import { isMobile } from 'react-device-detect';

import { THttpService } from '@/services/HttpService';

import {
  TDisplayedService,
  TInteractionButtonSendClick,
  TInteractionCardClick,
  TInteractionMoreInfo,
  TInteractionScroll,
  TInteractionClickComponent,
  TInteractionTabClick,
  TInteractionCloseModal,
} from './types';

// --- Interactions ---
const interactionPath = '/recommendation/interactions';

export const setInteractionCardClick = async (
  api: THttpService,
  {
    recommendationId,
    cards,
    cardId,
    cardPosition,
    tabName,
  }: TInteractionCardClick,
) => {
  await api.post(interactionPath, {
    recommendation_id: recommendationId,
    interaction_type: 'click_card',
    visible_cards: cards,
    clicked_card: cardId,
    card_position: cardPosition,
    variant_displayed: tabName.toLowerCase(),
    device: isMobile ? 'Mobile' : 'Desktop',
  });
};

export const setInteractionClickComponent = async (
  api: THttpService,
  { recommendationId, details }: TInteractionClickComponent,
) => {
  await api.post(interactionPath, {
    details,
    recommendation_id: recommendationId,
    interaction_type: 'click_component',
    device: isMobile ? 'Mobile' : 'Desktop',
  });
};

export const setInteractionScroll = async (
  api: THttpService,
  { recommendationId, cards, tabName }: TInteractionScroll,
) => {
  await api.post(interactionPath, {
    recommendation_id: recommendationId,
    interaction_type: 'scroll_cards',
    viewed_cards: cards,
    variant_displayed: tabName.toLowerCase(),
    device: isMobile ? 'Mobile' : 'Desktop',
  });
};

export const setInteractionTabClick = async (
  api: THttpService,
  { recommendationId, tabName }: TInteractionTabClick,
) => {
  await api.post(interactionPath, {
    recommendation_id: recommendationId,
    interaction_type: 'click_variant',
    variant_clicked: tabName.toLowerCase(),
    device: isMobile ? 'Mobile' : 'Desktop',
  });
};

export const setInteractionButtonSendClick = async (
  api: THttpService,
  { recommendationId, cards, tabName }: TInteractionButtonSendClick,
) => {
  await api.post(interactionPath, {
    recommendation_id: recommendationId,
    interaction_type: 'click_cta',
    visible_cards: cards,
    variant_displayed: tabName.toLowerCase(),
    device: isMobile ? 'Mobile' : 'Desktop',
  });
};

export const setInteractionMoreInfo = async (
  api: THttpService,
  { recommendationId, cards }: TInteractionMoreInfo,
) => {
  await api.post(interactionPath, {
    recommendation_id: recommendationId,
    interaction_type: 'click_explore_all_products',
    visible_cards: cards,
    device: isMobile ? 'Mobile' : 'Desktop',
  });
};

// --- Displayed ---
export const setDisplayedService = async (
  api: THttpService,
  { recommendationId }: TDisplayedService,
) => {
  api.post('/recommendation/displayed', {
    recommendation_id: recommendationId,
    device: isMobile ? 'Mobile' : 'Desktop',
  });
};

export const setInteractionCloseModal = async (
  api: THttpService,
  { recommendationId }: TInteractionCloseModal,
) => {
  await api.post(interactionPath, {
    recommendation_id: recommendationId,
    interaction_type: 'click_modal_close',
    device: isMobile ? 'Mobile' : 'Desktop',
  });
};
